import $api from "../http";
import { AxiosResponse } from "axios";
import { IPages, UserEnquiry } from "../models/IPages";

export default class PagesService {
  static async fetchPageContent(
    type: string
  ): Promise<AxiosResponse<IPages[]>> {
    return await $api.get<IPages[]>(`/page-management/${type}`);
  }

  static async fetchCreateOne(data: {
    type: string;
    content: IPages;
  }): Promise<AxiosResponse<IPages>> {
    return await $api.post<IPages>("/page-management", data);
  }

  static async fetchUpdateOne(
    data: FormData,
    type: string
  ): Promise<AxiosResponse<IPages[]>> {
    return await $api.put<IPages[]>(`/page-management/${type}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static async testFormData(
    type: string,
    data: FormData
  ): Promise<AxiosResponse<any>> {
    return await $api.post<any>(
      `/page-management/test-form-data/${type}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }


}
